type Tokens = {
  token: string;
  refreshToken: string;
};

let tokens: Tokens = {
  token: localStorage.getItem('token') || '',
  refreshToken: localStorage.getItem('refreshToken') || '',
};

const listeners = new Set<(tokens: Tokens) => void>();

export function getTokens(): Tokens {
  return tokens;
}

export const clearTokens = () => {
  tokens = {
    token: '',
    refreshToken: '',
  };

  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');

  for (const listener of listeners) {
    listener(tokens);
  }
};

export function setTokens(next: Tokens) {
  tokens = next;

  localStorage.setItem('token', tokens.token);
  localStorage.setItem('refreshToken', tokens.refreshToken);

  for (const listener of listeners) {
    listener(tokens);
  }
}

export function subscribe(listener: (tokens: Tokens) => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

import { useSyncExternalStore } from 'react';

export function useAuthTokens() {
  return useSyncExternalStore(subscribe, getTokens, getTokens);
}

if (typeof window !== 'undefined') {
  window.addEventListener('storage', event => {
    if (event.key !== 'token' && event.key !== 'refreshToken') {
      return;
    }

    const next: Tokens = {
      token: localStorage.getItem('token') || '',
      refreshToken: localStorage.getItem('refreshToken') || '',
    };

    if (
      next.token === tokens.token &&
      next.refreshToken === tokens.refreshToken
    ) {
      return;
    }

    tokens = next;

    for (const listener of listeners) {
      listener(tokens);
    }
  });
}
